const getDataProgram = (arrFetch, e, region, quiz = false) => {
  let arr = "",
    operator = '',
    link = '',
    program_id = null;

  if (!region) {
    return;
  }

  /* Проверяем это option или input */
  if (quiz == true) {
    e = e.target;
  } else {
    e.target ? (e = e.target.options[e.target.selectedIndex]) : e;
  }

  /* Фильтруем общий массив по shortname выбранной программы */
  let filterProgramArr = arrFetch.find(
    (item) => item.shortname == e.getAttribute("shortname")
  );

  if (filterProgramArr == undefined) {
    return {operator, program_id, link};
  }

  /* Получаем ссылку с отфильтрованного массива */
  arr = filterProgramArr.regions.find(
    (item) => item.region_id == region
  );

  /* ID Program */
  program_id = arr.program_id;
  
  /* Получение оператора и ссылки на РР */
  arr.fields.forEach(element => {    
    if (element.field == "funnel") {
        operator = element.value
    }  

    if (element.field == "rvr_link") {
        link = element.value
    }
  });
  
  return {operator, program_id, link};
};

export default getDataProgram;
